import _possibleConstructorReturn from "/Users/kirstymunro/Sites/sme-growth/cigna-frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/kirstymunro/Sites/sme-growth/cigna-frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/kirstymunro/Sites/sme-growth/cigna-frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/Users/kirstymunro/Sites/sme-growth/cigna-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/kirstymunro/Sites/sme-growth/cigna-frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import Cookies from 'js-cookie'; // Wrapper around js-cookie to share same Api as Storage (LocalStorage, SessionStorage)

export var Cookie =
/*#__PURE__*/
function () {
  function Cookie() {
    _classCallCheck(this, Cookie);

    this.storage = Cookies;
    this.storage.defaults.secure = location.protocol.indexOf('https') > -1;
    this.available = this.isAvailable();
  }

  _createClass(Cookie, [{
    key: "isAvailable",
    value: function isAvailable() {
      var testKey = '__cookie_test__';
      var canSet = false;

      if (this.available !== undefined) {
        return this.available;
      }

      try {
        // Create cookie
        document.cookie = "".concat(testKey, "=1");
        canSet = document.cookie.indexOf("".concat(testKey, "=")) !== -1; // Delete cookie

        document.cookie = "".concat(testKey, "=1; expires=Thu, 01-Jan-1970 00:00:01 GMT");
      } catch (err) {
        canSet = false;
      }

      return canSet;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (this.available) {
        return this.storage.set(key, value, options);
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var raw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.available) {
        var value = this.storage.get(key);

        if (!raw && /^[{[]/.test(value)) {
          try {
            value = JSON.parse(value);
          } catch (err) {// return normal
          }
        }

        return value === undefined ? defaultValue : value;
      }

      return defaultValue;
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (this.available) {
        return this.storage.remove(key, {
          domain: "".concat(domain)
        });
      }
    } // Slightly different api from Storage, needs options (path, domain, etc.) sometimes

  }, {
    key: "clear",
    value: function clear(prefix) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.available) {
        var prefixRegex = new RegExp("^".concat(prefix));
        Object.keys(this.storage.get()).forEach(function (key) {
          if (!prefix || key.match(prefixRegex)) {
            _this.storage.remove(key, options);
          }
        });
      }
    }
  }]);

  return Cookie;
}();

var Storage =
/*#__PURE__*/
function () {
  function Storage(type) {
    _classCallCheck(this, Storage);

    try {
      this.storage = window[type];
      this.available = this.isAvailable();
    } catch (err) {
      this.available = false;
    }
  }

  _createClass(Storage, [{
    key: "isAvailable",
    value: function isAvailable() {
      var testKey = '__storage_test__';
      var canSet = false;

      if (this.available !== undefined) {
        return this.available;
      }

      try {
        // to fully test, need to set item
        // http://stackoverflow.com/questions/9077101/iphone-localstorage-quota-exceeded-err-issue#answer-12976988
        this.storage.setItem(testKey, 1);
        this.storage.removeItem(testKey);
        canSet = true;
      } catch (err) {
        canSet = false;
      }

      return canSet;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (this.available) {
        if (typeof options.expires === 'number') {
          var expires = new Date();
          expires.setMilliseconds(expires.getMilliseconds() + options.expires * 864e+5);
          options.expires = expires;
        }

        value = JSON.stringify({
          value: value,
          expires: options.expires
        });
        return this.storage.setItem(key, value);
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var raw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.available) {
        var value = this.storage.getItem(key);

        if (value === null || value === undefined) {
          return defaultValue;
        }

        if (!raw) {
          try {
            value = JSON.parse(value);
          } catch (err) {
            this.remove(key);
            return defaultValue;
          }
        } else {
          return value;
        }

        if (value.expires && new Date() > new Date(value.expires)) {
          this.remove(key);
          return defaultValue;
        }

        return value.value;
      }

      return defaultValue;
    }
  }, {
    key: "remove",
    value: function remove(key) {
      if (this.available) {
        return this.storage.removeItem(key);
      }
    }
  }, {
    key: "clear",
    value: function clear(prefix) {
      if (this.available) {
        if (!prefix) {
          return this.storage.clear();
        }

        var i;
        var key;
        var prefixRegex = new RegExp("^".concat(prefix));

        for (i = this.storage.length - 1; i > -1; i -= 1) {
          key = this.storage.key(i);

          if (key.match(prefixRegex)) {
            this.storage.removeItem(key);
          }
        }
      }
    }
  }]);

  return Storage;
}();

export var LocalStorage =
/*#__PURE__*/
function (_Storage) {
  _inherits(LocalStorage, _Storage);

  function LocalStorage() {
    _classCallCheck(this, LocalStorage);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocalStorage).call(this, 'localStorage'));
  }

  return LocalStorage;
}(Storage);
export var SessionStorage =
/*#__PURE__*/
function (_Storage2) {
  _inherits(SessionStorage, _Storage2);

  function SessionStorage() {
    _classCallCheck(this, SessionStorage);

    return _possibleConstructorReturn(this, _getPrototypeOf(SessionStorage).call(this, 'sessionStorage'));
  }

  return SessionStorage;
}(Storage);
export var cookie = new Cookie();
export var local = new LocalStorage();
export var session = new SessionStorage();